import { logSetupGuideWarn } from "./logger";
import type { CompletionPredicate, Product, TaskId } from "./types";

/**
 * Wraps a predicate in try/catch. Throws are logged + treated as `false`
 * (incomplete) — the safe default. Without this wrapper, one bad predicate
 * (e.g. dereferencing undefined nested settings) would crash the entire
 * widget via React's error boundary, taking the dashboard with it.
 *
 * The throw indicates a bug in the predicate, not a runtime expectation —
 * the warn log is what triggers the fix.
 */
export function safePredicate(
  product: Product,
  taskId: TaskId,
  predicate: CompletionPredicate,
): CompletionPredicate {
  return (team, progress) => {
    try {
      return predicate(team, progress);
    } catch (err) {
      logSetupGuideWarn("setup-guide: predicate threw", {
        product,
        taskId,
        error: err instanceof Error ? err.message : String(err),
      });
      return false;
    }
  };
}
